__turbopack_context__.v({
  "app_light_theme": "total-popover-content-module-scss-module__Sqk4xq__app_light_theme",
  "totalPopoverContent": "total-popover-content-module-scss-module__Sqk4xq__totalPopoverContent",
  "totalPopoverContent__button": "total-popover-content-module-scss-module__Sqk4xq__totalPopoverContent__button",
  "totalPopoverContent__closeButton": "total-popover-content-module-scss-module__Sqk4xq__totalPopoverContent__closeButton",
});
